// extracted by mini-css-extract-plugin
module.exports = {"root":"small-form-popup-module--root--1tQHY","wrapper":"small-form-popup-module--wrapper--2UOFX","iconWrapper":"small-form-popup-module--iconWrapper--kAnix"};